var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"phone-filled","d":"M14.028,14.742l1.378-1.378a1.347,1.347,0,0,1,1.439-.3l1.679.67a1.341,1.341,0,0,1,.837,1.23v3.075a1.335,1.335,0,0,1-1.4,1.323C6.192,18.635,3.817,8.671,3.368,4.857A1.335,1.335,0,0,1,4.7,3.375H7.674a1.329,1.329,0,0,1,1.23.837l.67,1.679A1.329,1.329,0,0,1,9.285,7.33L7.907,8.707s.793,5.37,6.12,6.034Z","transform":"translate(-3.36 -3.375)"}));
}

Phone.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 16 15.994","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Phone;

Phone.default = Phone;
